import { useQuery } from '@tanstack/react-query'

import { getPriceListProducts } from '@/api/management'
import { keyStore } from '@/config/key-store'

function usePriceListProducts(id: number) {
  return useQuery({
    queryKey: [...keyStore.priceList.products.queryKey, id],
    queryFn: async () => await getPriceListProducts({ id }),
    refetchOnMount: false,
    enabled: !!id,
  })
}

export { usePriceListProducts }
